// © Microsoft Corporation. All rights reserved.

import { isArray, mergeWith } from "lodash-es";

import { ExperienceConfig } from "@msnews/config-data-types";

/**
 * Manifest Service class
 * This is for fetching and parsing the Manifest into an easily consumable form.
 */

/**
 * Merges config objects.
 * @private
 * @param {ExperienceConfigWrapper[]} configs - an array of config documents
 * @param {string} experienceType - experienceType
 * @return ExperienceConfig - returns merged config based on a set of rules
 */
export function mergeConfigs(configs: ExperienceConfig[]): ExperienceConfig {
    if (!configs || configs.length < 1) {
        return null;
    }

    const result: ExperienceConfig = configs[0];

    // skip the 0th item as it is assigned to result above, only merge properties section
    for (let count = 1; count < configs.length; count++) {
        result.properties = mergeWith(result.properties, configs[count].properties, configMergeCustomizer);
    }

    return result;
}

/**
 * Customizer for merge. We are explcitly overriding the array from taget to source. No array elements from source are preserved.
 * @private
 * @param {any} srcValue - source object to merge. Can be of type any
 * @param {any} objValue - target object to merge. Can be of type any
 * @return target Object when the type is array. Otherwise uses default behavior of merge.
 */
function configMergeCustomizer(srcValue: any, objValue: any): any {
    if (isArray(srcValue)) {
        return objValue;
    }
}
